import { useRef, useState, useEffect } from 'react';
import TextBoxNumericControl from "../../../Controls/TextBoxNumericControl"
import TextBoxControl from "../../../Controls/TextBoxControl"
import ButtonControl from "../../../Controls/ButtonControl"
import GridControl from "../../../Controls/GridControl"
import DescriptionControl from "../../../Controls/DescriptionControl"
import { useNavigate } from "react-router-dom";
import TextAreaControl from "../../../Controls/TextAreaControl";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ShowOwnerResidentialInfo from "../../../Controls/ShowOwnerResidentialInfo"

import { 
	GetLocal,
	SetLocal,
	FetchService,
	IsEmptyInput
} from "../../../Base/BaseControl";
import { toast } from 'react-toastify';
import { EmployeeSessionCheckFetch } from '../../../Base/BasePageEmployee';

let ServiceUrlCheckBox = '';
let ShowSuccess = null;
let ResultRow = '';

export default function Index(props) {
    const inputRef = useRef(null);
	const navigate = useNavigate();

	const [getServiceResult, setServiceResult] = useState(false);
	const [showModal, setShowModal] = useState(false);	
	const [getPdf, setPdf] = useState('');	
	
    useEffect(() => {
        var inputValue = {
			  session: GetLocal('EmployeeSession'),
			  fileNumber: GetLocal('FileNumber')			  
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Request/ShowRequestsReview", inputValue, ShowRequestsReviewSuccess);		
    }, []);

	const ShowRequestsReviewSuccess =(ServiceResult)=>{
		setServiceResult(ServiceResult.RequestsReviewList);
	}

	/*const EditAction =(value)=>{
        var inputValue = {
			  session: GetLocal('EmployeeSession'),
			  internetRequestNumber: value.InternetRequestNumber		  
        };
        FetchService("Employee/Urbanization/Request/GetRequestsReview", inputValue, GetRequestsReviewSuccess, GetRequestsReviewFail);		
	}	

	const GetRequestsReviewSuccess =(ServiceResult)=>{
		setPdf("data:application/pdf;base64,"+ServiceResult);
		setShowModal(true)
	}	

	const GetRequestsReviewFail =(ServiceResult)=>{
		setShowModal(false)
	}*/	

	const EditAction =(row)=>{
		window.location.href="/Employee/SubmitRequest?InternetRequestNumber="+row.InternetRequestNumber+"&page=ثبت درخواست";
	}	

    return (
		<div class="text-center my-4">
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')}/>
			
			<GridControl
				data={getServiceResult}
				customHeaders={{"RequestReviewDate": "تاریخ","FullName": "نام / نام خانوادگی","RequestType": "نوع درخواست","Status":"وضعیت","DisapprovalReason":"علت عدم تایید","EditAction":"ویرایش"}}	
				EditAction={EditAction} 
			/>
			
			<Modal dialogClassName="modalUi" show={showModal} onHide={()=>setShowModal(false)}>
			<Modal.Header closeButton>
			  <Modal.Title></Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<iframe src={getPdf} width="100%" style={{height:"500px"}}></iframe>				
			</Modal.Body>
			<Modal.Footer>
			  <Button variant="danger" onClick={()=>setShowModal(false)}>
				بستن
			  </Button>
			</Modal.Footer>
			</Modal>				
		</div>
    );
}
